import createCachedSelector from 're-reselect';

const defaultShareHolders = {
  summaryLoaded: false,
  summary: null
};

export const getShareholdersData = (state, partnerId) => {
  return state.currentOffer.clientShareholdersData[partnerId] || defaultShareHolders;
};

export const getShareholdersSummary = createCachedSelector(getShareholdersData, data => data.summary || [])((_, partnerId) => partnerId);

export const getShareholdersSummaryIsLoaded = createCachedSelector(
  getShareholdersData,
  data => data.summaryLoaded
)((_, partnerId) => partnerId);
